import type { App } from 'vue';

import { useRouteStore } from '@nora-monorepo/ui-shared';

const urlGuardDirective = {
  beforeMount(element: HTMLElement) {
    element.addEventListener('click', (event: MouseEvent) => {
      urlGuardClickHandler(element, event);
    });
  },
  unmounted(element: HTMLElement) {
    element.removeEventListener('click', (event: MouseEvent) =>
      urlGuardClickHandler(element, event));
  },
};

export function installUrlGuardDirective(app: App): void {
  app.directive('url-guard', urlGuardDirective);
}

const whitelist: string[] = [];

export function urlGuardClickHandler(element: HTMLElement, event: MouseEvent): void {
  let linkElement: HTMLAnchorElement | null = null;
  if (element instanceof HTMLAnchorElement) {
    linkElement = element;
  }
  else {
    linkElement = element.closest('a');
  }

  if (!linkElement) {
    return;
  }

  const routeStore = useRouteStore();
  const href = linkElement.getAttribute('href');

  if (!href) {
    return;
  }

  const isExternalLink = /^https?:\/\//.test(href);

  if (isExternalLink && !whitelist.includes(href)) {
    event.preventDefault();

    routeStore.openExternalUrlDialog(href);
  }
}
